"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToTimelines = void 0;
const StoryTeller_1 = require("../../StoryTeller");
/**
 * !!! This is a MAJOR migration !!!
 * This migration got introduced because we need a better way to handle timeline data and navigation
 * so we can introduce minted choices
 */
const timelineIdMap = {
    a: 't2',
    b: 't3',
    c: 't4',
};
const newChoiceIdMap = {
    a: 'c1',
    b: 'c2',
    c: 'c3',
};
const charSlotIdMap = {
    a: 'cs1',
    b: 'cs2',
    c: 'cs3',
};
const getNewGestures = (gestures) => {
    const newGestures = gestures.reduce((res, cur) => {
        const charSlotId = charSlotIdMap[cur.charID];
        return {
            ...res,
            [charSlotId]: {
                charSlotId,
                dirX: cur.dirX,
                animation: cur.gesture,
                loop: cur.loop,
                charPos: cur.charPos,
                charMotion: cur.charMotion,
            }
        };
    }, {});
    return newGestures;
};
const getNewCamera = (camera) => {
    if (!camera) {
        return undefined;
    }
    const newCamera = {
        ...camera,
        charSlotId: camera.charID ? charSlotIdMap[camera.charID] : undefined,
    };
    delete newCamera.charID;
    return newCamera;
};
const getNewBubble = (bubble) => {
    if (!bubble) {
        return undefined;
    }
    const newBubble = {
        ...bubble,
        charSlotId: bubble.charID ? charSlotIdMap[bubble.charID] : undefined,
    };
    delete newBubble.charID;
    return newBubble;
};
const getStepProps = ({ gestures, parallax, camera, bubble, choices }) => ({
    gestures: getNewGestures(gestures),
    parallax,
    camera: getNewCamera(camera),
    bubble: getNewBubble(bubble),
    choices,
});
const getNewSteps = (firstStep, steps) => {
    const stepsObj = {};
    let step = firstStep;
    let count = 1;
    // if we only have the first step
    if (steps.length === 1 && firstStep === steps[0]) {
        stepsObj[`s${count}`] = {
            ...getStepProps(step),
            nextStep: undefined,
            prevStep: undefined,
        };
        return stepsObj;
    }
    while (step === null || step === void 0 ? void 0 : step.navigation.next) {
        const key = `s${count}`;
        const nextStep = `s${count + 1}`;
        const prevStep = count === 1 ? undefined : `s${count - 1}`;
        stepsObj[key] = {
            ...getStepProps(step),
            nextStep,
            prevStep,
        };
        count++;
        step = steps.find(s => s.navigation.id === (step === null || step === void 0 ? void 0 : step.navigation.next));
        // is the last step in this timeline
        if (step && !(step === null || step === void 0 ? void 0 : step.navigation.next)) {
            const choices = step.choices ? Object.keys(step.choices).reduce((res, cur) => {
                const { caption } = step.choices[cur];
                return {
                    ...res,
                    [newChoiceIdMap[cur]]: {
                        toTimeline: timelineIdMap[cur],
                        caption,
                    }
                };
            }, {}) : undefined;
            stepsObj[nextStep] = {
                ...getStepProps(step),
                choices,
                prevStep: `s${count - 1}`,
                nextStep: undefined,
            };
        }
    }
    return stepsObj;
};
const getOrderedStepKeys = (steps) => {
    return Object.keys(steps).sort((a, b) => {
        return Number(a.replace('s', '')) - Number(b.replace('s', ''));
    });
};
const migrateToTimelines = async (dialog) => {
    var _a, _b, _c;
    const steps = dialog.steps;
    const rootTimelineId = StoryTeller_1.INITIAL_TIMELINE;
    const timelines = {};
    const rootSteps = [];
    const timelineSteps = {};
    const choices = (_a = steps.find(s => s.choices)) === null || _a === void 0 ? void 0 : _a.choices;
    for (const step of steps) {
        const parent = step.navigation.parent;
        if (!parent) {
            rootSteps.push(step);
            continue;
        }
        if (choices) {
            if (choices.a.navigation.parent === parent) {
                if (!timelineSteps.a) {
                    timelineSteps.a = [];
                }
                timelineSteps.a.push(step);
            }
            else if (((_b = choices.b) === null || _b === void 0 ? void 0 : _b.navigation.parent) === parent) {
                if (!timelineSteps.b) {
                    timelineSteps.b = [];
                }
                timelineSteps.b.push(step);
            }
            else if (((_c = choices.c) === null || _c === void 0 ? void 0 : _c.navigation.parent) === parent) {
                if (!timelineSteps.c) {
                    timelineSteps.c = [];
                }
                timelineSteps.c.push(step);
            }
        }
    }
    const initialStep = dialog.initialStep;
    let step = rootSteps.find(s => s.navigation.id === initialStep);
    if (!step) {
        throw new Error(`Something really wrong happened. Cannot find step with 'initialStep' in 'rootSteps'`);
    }
    const newSteps = getNewSteps(step, rootSteps);
    const stepIds = getOrderedStepKeys(newSteps);
    timelines[rootTimelineId] = {
        root: rootTimelineId,
        lastStep: stepIds[stepIds.length - 1],
        firstStep: StoryTeller_1.INITIAL_STEP,
        steps: newSteps,
        toTimeline: undefined,
        mergeTimeline: undefined,
    };
    if (choices) {
        for (const choiceId of Object.keys(timelineSteps)) {
            const timelineId = timelineIdMap[choiceId];
            const steps = timelineSteps[choiceId];
            const initialStep = steps.find(s => { var _a; return (_a = s.navigation.parent) === null || _a === void 0 ? void 0 : _a.includes(s.navigation.id); });
            if (!initialStep) {
                throw new Error(`Error: Could not find 'initialStep' for timeline '${timelineId}'`);
            }
            const newSteps = getNewSteps(initialStep, steps);
            const stepIds = getOrderedStepKeys(newSteps);
            timelines[timelineId] = {
                root: rootTimelineId,
                lastStep: stepIds[stepIds.length - 1],
                firstStep: StoryTeller_1.INITIAL_STEP,
                steps: newSteps,
                toTimeline: undefined,
                mergeTimeline: undefined,
            };
        }
    }
    const charSlots = Object.keys(dialog.characters).reduce((res, cur) => {
        const id = charSlotIdMap[cur];
        const char = dialog.characters[cur];
        const charMetadata = dialog.charactersMetadata[cur];
        const charSlot = {
            ...char,
            id,
            charMetadata,
            overrideable: undefined,
        };
        return {
            ...res,
            [id]: charSlot
        };
    }, {});
    const data = {
        ...dialog,
        rootTimelineId,
        timelines,
        charSlots,
        choicesMade: {},
        // Clear deprecated props
        characters: undefined,
        charactersMetadata: undefined,
        parallax: undefined,
        initialStep: undefined,
        steps: undefined,
        timestamp: undefined,
        lastVersion: undefined,
        version: undefined,
        saveCount: undefined,
        editedBy: undefined,
    };
    // Remove undefined props
    return JSON.parse(JSON.stringify(data));
};
exports.migrateToTimelines = migrateToTimelines;
//# sourceMappingURL=migrateToTimelines.js.map